import { getHours } from "date-fns";
import { BestShippingOption } from "../../types/product_availability/availability_types";
import { DeliveryDate } from "../../types/product_availability/delivery_types";
import addBusinessDays, { isBusinessDay } from "./add_business_days";

export const calculateDeliveryDate = (
  shippingOption: BestShippingOption,
  now: Date
): DeliveryDate => {
  // See if we can order from the supplier today, or we'll need to do it the next
  // business day
  const isSupplierOrderDelayedByCutOff =
    getHours(now) >= shippingOption.supplierOrderCutOffTime ||
    !isBusinessDay(now);
  const supplierOrderCutOffDelay = isSupplierOrderDelayedByCutOff ? 1 : 0;

  // If we missed the cut-off time, we'll need to ship the next day at the earliest,
  // unless we are already delayed by supplier order cut-off time.
  const isShippingDelayedByCutOff =
    shippingOption.supplierShippingDays === 0 &&
    supplierOrderCutOffDelay === 0 &&
    getHours(now) >= shippingOption.carrierCutOffTime &&
    isBusinessDay(now);
  const carrierCutOffDelay = isShippingDelayedByCutOff ? 1 : 0;

  return {
    receiveFromSupplierOn: addBusinessDays(
      now,
      supplierOrderCutOffDelay + shippingOption.supplierShippingDays
    ),
    deliverOn: addBusinessDays(
      now,
      supplierOrderCutOffDelay +
        carrierCutOffDelay +
        shippingOption.supplierShippingDays +
        shippingOption.carrierShippingDays
    ),
    supplierOrderCutOffDelay,
    carrierCutOffDelay,
  };
};
